import { fetchCredits } from "@/services/heygen/dashboard/fetchCredits";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Loading } from "@/components/ui/loading";
import { ExternalLink } from "lucide-react";

export function RemainingCredits() {
  const { t } = useTranslation();
  const { data, error, isLoading } = useQuery({
    queryKey: ["credits"],
    queryFn: fetchCredits
  });

  if (error) {
    return <div>{t("common.error", { message: error.message })}</div>;
  }

  if (isLoading) {
    return (
      <div className="flex gap-2 items-center relative">
        <div className="text-lg">{t("infoSection.creditsConsumed")}</div>
        <Loading inline spinnerSize="h-4 w-4" messageKey="common.loading" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-2 items-center">
        <div className="text-lg">{t("infoSection.creditsConsumed")}</div>
        <div className="font-semibold">{data?.credits ?? "–"}</div>
      </div>
      <a
        href="https://app.liveavatar.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors"
      >
        {t("infoSection.viewFullBalance")}
        <ExternalLink size={12} />
      </a>
    </div>
  );
}
